import {maybeIOS} from "@khan/guide-core-helpers";
import {GuideStateApi} from "@khan/guide-state";
import {RequestInfo, type UserAttributes} from "@khan/shared-core";

/**
 * Returns true if we should enable the Notification Action Bubble feature for
 * the user.
 */
export const isNABFeatureEnabled = (
    userAttributes: UserAttributes | null | undefined,
): boolean => {
    if (!userAttributes) {
        return false;
    }

    const hasAcknowledgedGuide = GuideStateApi.latest().hasAcknowledgedGuide;
    // Unfortunately, we can't use the `isMobile` flag from `RequestInfo` to
    // reliably determine if the user is on a mobile device since modern iPads
    // have a user agent that is indistinguishable from a desktop browser. We
    // fallback to also checking maybeIOS() to determine if the user is on a
    // such a device.
    const isMobile = RequestInfo.isMobile || maybeIOS();
    if (isMobile || !hasAcknowledgedGuide) {
        return false;
    }

    return true;
};
